export default __webpack_public_path__ + "318a964aee4018ebfd9871f93a880591.svg";